import React, { useEffect, useState } from "react";
import "./styles/Banner.css";

const KINDS = {
  offline: { icon: "⚠", cls: "banner-offline" },
  ratelimit: { icon: "⏳", cls: "banner-ratelimit" },
  error: { icon: "✕", cls: "banner-error" },
};

/**
 * Offline / rate-limit / error banner. `retryInMs` (ratelimit) renders an
 * auto-updating countdown. `onRetry` adds a manual retry button.
 */
export default function Banner({ kind, message, retryInMs, onRetry }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (retryInMs == null) return undefined;
    const id = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(id);
  }, [retryInMs]);

  if (!kind) return null;
  const { icon, cls } = KINDS[kind] || KINDS.error;
  const seconds =
    retryInMs != null ? Math.max(0, Math.ceil((retryInMs - now) / 1000)) : null;

  return (
    <div className={`banner ${cls}`} role={kind === "offline" ? "alert" : "status"} aria-live="polite">
      <span className="banner-icon" aria-hidden="true">{icon}</span>
      <span className="banner-msg">
        {message}
        {seconds !== null && seconds > 0 ? ` — retrying in ${seconds}s` : ""}
      </span>
      {onRetry && (
        <button type="button" className="banner-retry" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}
